import styled from 'styled-components';

const Container = styled.div`
  font-size: 14px;
  line-height: 1.3;
`;

const ListDescription = ({ description, style = {} }) => {
  return (
    <Container style={style}>
      <div>{description}</div>
    </Container>
  );
};

export default ListDescription;
